import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import PlaceholderImage from './user.svg'

export const AvatarImage = ({ name, image }) => {
  const [src, setSrc] = useState(image)

  useEffect(() => setSrc(image), [image])

  const text = useMemo(() => {
    if (typeof name === 'string') {
      return name
        .split(/\s/)
        .map((part) => part.substring(0, 1).toUpperCase())
        .filter((x) => !!x)
        .slice(0, 2)
        .join('')
        .toUpperCase()
    }

    return 'G'
  }, [name])

  if (image) {
    return (
      <img
        src={src}
        draggable={false}
        className="--avatar-image"
        onError={() => setSrc(PlaceholderImage)}
      />
    )
  }

  return <div className="--avatar-text">{text}</div>
}

AvatarImage.propTypes = {
  name: PropTypes.string,
  image: PropTypes.string,
}

AvatarImage.defaultProps = {
  name: '',
  image: '',
}

export default AvatarImage
